import React from 'react'

export const FloatingAgentMessageContext = React.createContext<boolean>(false)

export function useFloatingAgentMessage(): boolean {
  return React.useContext(FloatingAgentMessageContext)
}
